<template>
  <div
    class="ag-grid__overlay-form-box"
  >
    <div class="ag-grid__overlay-form-box-title">
      Block Numbers
    </div>
    
    <div class="p-15">
      <ValidationObserver
        ref="formValidation"
        v-slot="{ invalid }"
        slim
      >
        <div
          class="col-md-offset-3"
        >
          <BulkCallDetails
            :key="bulkCallReviewKey"
            :selected-calls="selectedCalls"
            @unselectCallOnBulkAction="unselectCallOnBulkAction"
          />

          <p class="m-t-10 text-muted">
            <strong>
              {{ $t('NOTE_BULK_BLOCK_NUMBER') }}
            </strong>
          </p>

          <form class="form-horizontal m-t-20">
            <BaseFormField
              :label="$t('SPECIFY_DURATION_LABEL')"
              :tooltip-text="$t('SPECIFY_DURATION_TT')"
              has-tooltip
              class="form-group"
            >
              <div class="col-md-2">
                <ValidationProvider
                  v-slot="{ errors, classes }"
                  rules="min_value:1"
                  slim
                >
                  <input
                    v-model="expInHour"
                    name="timePeriod"
                    type="number"
                    min="1"
                    :placeholder="$t('DURATION_HOURS_UNIT')"
                    class="form-control m-b-0"
                    :class="classes"
                  >
                </ValidationProvider>
              </div>
            </BaseFormField>

            <BaseFormField
              :label="$t('BLOCK_ACCOUNT_WIDE_LABEL')"
              :tooltip-text="$t('BLOCK_ACCOUNT_WIDE_TT')"
              has-tooltip
              class="form-group"
            >
              <div class="col-md-3">
                <NzToggle 
                  v-model="blockAccountWide"
                />
              </div>
            </BaseFormField>
          </form>
  
          <div>
            <PrimaryButton
              class="m-t-15"
              size="sm"
              :disabled="invalid"
              :show-loader-on-form="showLoader"
              @click="handleBlockNumbers"
            >
              {{ $t('BLOCK_NUMBERS') }}
            </PrimaryButton>
  
            <button
              v-t="'CANCEL'"
              class="btn btn-danger btn-sm m-t-15 m-l-10"
              @click="hideBulkForm"
            />
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import {uniqWith} from 'lodash';

import messages from './locales';
import sharedMessages from '@/core/locales';
import BulkCallDetails from '../BulkCallDetails';
import PrimaryButton from '@/core/components/PrimaryButton';
import NzToggle from '@/core/components/nzToggle/nzToggle';
import BaseFormField from '@/core/components/Form/BaseFormField';
import bulkCallActionMixin from './mixins/bulkCallActionMixin';

export default {
  name: 'BulkBlockNumbers',
  components: {
    BulkCallDetails,
    PrimaryButton,
    NzToggle,
    BaseFormField
  },

  mixins: [bulkCallActionMixin],

  data() {
    return {
      expInHour: undefined,
      blockAccountWide: false
    };
  },

  methods: {
    handleBlockNumbers() {
      this.$emit('bulkBlockNumbers', uniqWith(this.selectedCalls.map(call => {
        return {
          phoneNumber: call.inboundPhoneNumber,
          campaignId: this.blockAccountWide ? undefined : call.campaignId,
          blockAllCampaigns: false,
          blockAnonymousCallers: false,
          expInHour: this.expInHour
        };
      }), (arrVal, othVal) => {
        return arrVal.phoneNumber === othVal.phoneNumber && arrVal.campaignId === othVal.campaignId;
      } ));
    }
  },

  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>

</style>